import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { formatDate } from '../../data/reportCopy'
import styles from './ReferenceSection.module.scss'

const renderStrong = (chunks) => <strong>{chunks}</strong>

export default function ProvenanceCard({ meta, provenanceSummary }) {
  const intl = useIntl()
  const counts = provenanceSummary.counts ?? {}

  return (
    <div className={styles.referenceCard}>
      <h3>
        <FormattedMessage id="AI_RISK_REPORT.REFERENCE.PROVENANCE_TITLE" />
      </h3>
      <p>
        <FormattedMessage
          id="AI_RISK_REPORT.REFERENCE.PROVENANCE_BODY"
          values={{
            date: formatDate(intl, meta.generatedAt),
            completeness: provenanceSummary.completenessPct ?? 0,
            accessed: counts.accessed ?? 0,
            notAccessed: counts.notAccessed ?? 0,
            comingSoon: counts.comingSoon ?? 0,
            strong: renderStrong,
          }}
        />
      </p>
    </div>
  )
}

ProvenanceCard.propTypes = {
  meta: PropTypes.shape({ generatedAt: PropTypes.string }).isRequired,
  provenanceSummary: PropTypes.shape({ completenessPct: PropTypes.number, counts: PropTypes.shape({}) }).isRequired,
}
